module.exports = __webpack_public_path__ + "media/application/images/2024/shapes/17-25c86e34692118e62e51dd1830210fa7.png";